import { VERSION } from '@/lib/utils';

const footer = () => {
  return (
    <footer className="container mx-auto px-4 py-8 text-center text-sm text-secondary ">
      <p>
        &copy; {new Date().getFullYear()} Mentoria Fernando Vasconcelos. Todos os direitos
        reservados.
      </p>
      <p>Versão {VERSION}</p>
    </footer>
  );
};

export default footer;
